export default {
  banner: {
    description: "Ottieni {{range}} di sconto ordinando tramite l'app gratuita FoodAmigos. Clicca qui per scaricarla →",
  },
  labels: {
    deals: 'Offerte',
    collecting_points: 'Stai già raccogliendo punti?',
    earn_points: 'Guadagna punti e ottieni premi ',
    order_again: 'Ordina di nuovo',
  },
  checkout_button: {
    title: 'Vai al carrello',
  },
};
